<script>
export default {
  name: "DidoMillesimeBlockApiVars",
};
</script>

<script setup>
import { ref, watch } from "vue";
import api from "../../../api";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
  columns: { type: Array, required: true },
});

// define reactive data
const filteredColumns = ref(props.columns);
const searchText = ref("");

// define watchers
watch(
  () => props.columns,
  () => refresh(),
);

// define methods
const filter = () => {
  filteredColumns.value = props.columns.filter(({ name, description }) => {
    const regex = new RegExp(`${searchText.value}`, "i");
    return regex.test(name) || regex.test(description);
  });
};
const refresh = () => {
  searchText.value = "";
  filter();
};
const refOfColumn = (column) => {
  return api.refTitle(column.ref);
};
</script>

<template>
  <div class="q-pa-md">
    <QInput
      v-model="searchText"
      dense
      color="secondary"
      label-color="secondary"
      outlined
      label="Filtrer les colonnes"
      @update:model-value="filter"
    >
      <template #prepend>
        <QIcon name="mdi-magnify" color="secondary" />
      </template>
    </QInput>
    <div class="q-mt-md row justify-center items-stretch q-gutter-sm">
      <div
        v-for="(column, colIdx) of filteredColumns"
        :key="colIdx"
        class="dido-millesime-column q-ma-sm bg-white border-secondary"
      >
        <div class="q-pa-xs bg-secondary text-white text-subtitle2">
          {{ column.name }}
        </div>
        <div class="dido-millesime-column-description q-pa-sm text-overline">
          {{ column.description }}
        </div>
        <div v-if="column.unit" class="q-pa-sm text-caption text-italic">
          Unité : {{ column.unit }}
        </div>
        <div class="q-pa-sm text-caption text-italic">
          Type
          <a
            href="https://specs.frictionlessdata.io/table-schema/"
            title="Spécifications Table Schema"
            >Table Schema</a
          >
          : {{ column.type }}
          <span v-if="column.format">({{ column.format }})</span>
        </div>
        <div v-if="column.ref" class="q-pa-sm text-caption text-primary">
          {{ refOfColumn(column) }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.dido-millesime-column
  width: 250px
  max-width: 250px
.dido-millesime-column-description
  line-height: 20px
</style>
